import PropTypes from 'prop-types';
import React from 'react';

export default function Spin({
  i18n,
}) {
  return <span>{i18n.getString(_TL_('Loading...'))}</span>;
}

Spin.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};
